package tta.destinigo.talktoastro.feature_profile.component

sealed class PrivacyPolicyEvent {
    data object OnBackKeyPress: PrivacyPolicyEvent()
}